<template>
    <div class="dialog-wrapper" v-if="dialogData">
        <div class="dialog-inner">
            <div class="dialog-content">
                <p v-html="dialogData.text" v-if="dialogData.text"></p>
                <p class="sub-text" v-html="dialogData.subText" v-if="dialogData.subText"></p>
                <div class="dialog-btns" v-if="dialogData.btns">
                    <div class="dialog-btn" :class="[btn.className]" @click="btnClick(btn)" v-for="btn in dialogData.btns"><span>{{btn.text}}</span></div>
                </div>
            </div>               
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

import HongBao from '@/components/HongBao.vue'

import Moment from 'moment'

import COVERAPP from '@/utils/COVERAPP'

@Options ({
    data () {
        return {
            showHb: false
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'dialogData', 'activityData'])
    },
    components: {
        HongBao
    },
    methods: {
        ...mapMutations(['SET_DIALOGDATA', 'SET_USERINFO', 'SET_HBDATA']),
        btnClick (btn: any) {
            if (btn.className === 'wxAuthorize-btn') {
                this.$common.track(this.aid, 'click', '绑定微信')
                this.wxAuthorize()
            } else if (btn.className === 'download-btn') {
                this.downloadApp(btn.data)
            } else if (btn.className === 'getHb-btn') {
                this.$common.track(this.aid, 'click', '新人惊喜礼')
                this.SET_HBDATA(true)
                this.SET_DIALOGDATA(null)
            } else {
                this.SET_DIALOGDATA(null)
            }
        },
        wxAuthorize() {
            let _this = this
            COVERAPP.Method.wxAuthorize({
                callback(res: any) {
                    let data = typeof res == 'string'.toLowerCase() ? res : JSON.stringify(res)
                    if (JSON.parse(data).status == 1) {
                        _this.SET_DIALOGDATA(null)
                        const openid = JSON.parse(data).openid
                        let verifyOpenid = `${_this.userInfo.user_id.toString(36)}_${openid}_${(+Moment().format("YYYYMMDD")).toString(36)}`
                        let userInfo = JSON.parse(JSON.stringify(_this.userInfo))
                        userInfo.openid = openid
                        _this.SET_USERINFO(userInfo)
                        _this.$nextTick(() => {
                            _this.bindWeixin(verifyOpenid)
                        })
                    }
                }
            })
        },
        bindWeixin (openid: string) {
            this.$request('/user/weixin/bind', {
                openid: openid,
                userinfo: this.userInfo
            }, 'put').then((data: any) => {
                this.SET_DIALOGDATA(null)
                this.$common.toast('绑定微信成功')
            }).catch((res: any) => {
                if (res.errno == 1251) {
                    this.SET_DIALOGDATA({
                        text: '您的微信号已授权，不能重复授权哦！',
                        btns: [
                            {
                                text: '确定'
                            }
                        ]
                    })
                } else {
                    this.$common.toast('绑定微信失败')
                }
            })
        },
        downloadApp (data: any) {
            this.$common.downloadApp(this.aid, data.news_id, data.flag)
        }
    }
})
export default class Dialog extends Vue {}
</script>

<style lang="scss">
.dialog-wrapper {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 40;
    background-color: rgba($color: #000000, $alpha: .4);
    display: flex;
    justify-content: center;
    align-items: center;
}
.dialog-inner {
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: .241546rem;
    min-height: 3.94525rem;
    display: flex;
    align-items: center;
    animation: fadeIn .6s forwards;
    .dialog-content {
        padding: .5rem 0;
    }
    p {
        font-size: .402576rem;
        color: #fff;      
        line-height: 1.7;
        padding: 0 .772947rem;
        white-space: nowrap;
        text-align: center;
        &.sub-text {
            font-size: .231481rem;
            opacity: .6;
        }
    }
    .dialog-btns {
        display: flex;
        justify-content: center;
        margin-top: .4rem;
        .dialog-btn {
            height: .888889rem;
            display: inline-flex;
            justify-content: center;
            background: linear-gradient(#fd4144, #d7151b);
            border-radius: .444444rem;
            padding: 0 .509259rem 0 .555556rem;
            align-items: center;
            position: relative;
            cursor: pointer;
            margin: 0 .2rem;
            &::before {
                content: '';
                position: absolute;
                left: .12963rem;
                top: .083333rem;
                width: .694444rem;
                height: .277778rem;
                background: url('../assets/img/btn_light.png') no-repeat left top;
                background-size: 100% 100%;
            }
            span {
                font-size: .407407rem;
                color: #fff;
                line-height: 1.4;
                letter-spacing: .046296rem;
            }
            &.close-btn {
                background: linear-gradient( #515151, #999898);
            }
        }
    }
}
</style>
